import SvgIcon from '../SvgIcon/SvgIcon';

function FacebookIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <path d="M13.14,20.07v-7.3h2.62l.4-2.85h-3V8.11c0-.83.24-1.39,1.51-1.39h1.61V4.18a21.64,21.64,0,0,0-2.35-.11C11.58,4.07,10,5.39,10,7.82v2.1H7.36v2.85H10v7.3Z" />
    </SvgIcon>
  );
}

export default FacebookIcon;
